import {Patient} from "./patient.model";
import {LameSondeCalculator} from "./lame-sonde-calculator";

export class AcrResults {
  lame: string;
  sonde: string;
  chocValue: number;
  adreX: number;
  adrenaline_ivd: number;
  adreY: string;
  adreZ: string;
  amioX: number;
  amioXtotal: string;
  amioY: number;
  amioZ: number;
  amioZ2: string;
  lameSondeCalculator = new LameSondeCalculator();

  constructor(patient: Patient) {
    this.initResults(patient)
  }

  private initResults(patient: Patient) {
    this.chocValue = Math.min(10 * Math.round(4 * patient.weight / 10), 150);

    let lameSondeResult = this.lameSondeCalculator.getLameSonde(patient.weight);
    this.lame = lameSondeResult.lame;
    this.sonde = lameSondeResult.sonde;

    // ADRENALINE
    if (patient.weight <= 47) {
      // let tmp1 = Math.trunc((10 * patient.weight) / 5);
      // let rest = Math.trunc((10 * patient.weight) % 5);
      // this.adrenaline_ivd = (5 * tmp1 + (rest > 2.5 ? 5 : 0));
      this.adrenaline_ivd = 10 * patient.weight;

      if (patient.weight > 10) {
        this.adreZ = "Ampoule 1 mg/1 ml + seringue 10ml. Prélevez la totalité, compléter à 10 ml avec NaCl 0.9%";
        this.adreX = patient.weight * 0.1 ;
      }
      else {
        this.adreZ = "Ampoule 1 mg/1 ml + seringue 1ml. Prélevez 0.1 ml, compléter à 1 ml avec NaCl 0.9%";
        this.adreX = patient.weight * 0.1 ;
      }

    } else {
      this.adreY = "Adrénaline 1mg";
      this.adreZ = "Ampoule 1 mg/1 ml";
      this.adreX = 1;
    }

    this.amioY = Math.min(5 * patient.weight, 300);
    if (patient.weight < 30) {
      this.amioZ = -1 ;
      this.amioZ2 = "compléter à 15 ml avec G5%;";
      this.amioX = this.amioY / 10;

    } else {
      this.amioZ = this.amioY / 50;
      this.amioZ2 = "compléter à 20 ml avec G5%";
      this.amioX = 20;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/acr-results.model.ts